import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useAdminDatasetPermissionsQuery } from '../../api/admin';
import AdminGridLink from './AdminGridLink';
import AdminQuickFilterToolbar from './AdminQuickFilterToolbar';

interface Props {
	datasetId: number;
}

function formatDay(value: string | null | undefined): string {
	return value ? new Date(value).toLocaleDateString('en-CA') : '';
}

const columns: GridColDef[] = [
	{
		field: 'full_name',
		headerName: 'Name',
		flex: 1,
		minWidth: 160,
		renderCell: (params: GridRenderCellParams) => (
			<AdminGridLink
				to={`/admin/users/${params.row.user_id}`}
				state={{ userEmail: params.row.email, userName: params.row.full_name }}
			>
				{params.value}
			</AdminGridLink>
		),
	},
	{ field: 'email', headerName: 'Email', flex: 1.2, minWidth: 200 },
	{
		field: 'organization_names',
		headerName: 'Organization',
		flex: 1,
		minWidth: 140,
	},
	{
		field: 'team_names',
		headerName: 'Team',
		flex: 1,
		minWidth: 120,
	},
	{
		field: 'access_from',
		headerName: 'Date Added',
		width: 120,
		valueFormatter: ({ value }) => formatDay(value),
	},
	{
		field: 'updated_at',
		headerName: 'Last Updated',
		width: 120,
		valueFormatter: ({ value }) => formatDay(value),
	},
	{
		field: 'ticker_subset',
		headerName: 'Ticker Subset',
		flex: 1.5,
		minWidth: 160,
	},
];

/** Every active user with an active permission on one dataset. */
export default function DatasetPermissionsTable({ datasetId }: Props) {
	const { data: permissions, isLoading } = useAdminDatasetPermissionsQuery(datasetId);

	return (
		<Box sx={{ height: 'calc(100vh - 300px)', minHeight: 400, width: '100%' }}>
			<DataGrid
				rows={permissions ?? []}
				columns={columns}
				loading={isLoading}
				density="compact"
				disableSelectionOnClick
				components={{ Toolbar: AdminQuickFilterToolbar }}
				componentsProps={{ toolbar: { showQuickFilter: true } }}
			/>
		</Box>
	);
}
